import React, { useEffect } from 'react';
import './main.scss';
import './index.css';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LoginService } from '@ey/mfe-ui-core';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { EventMessage, EventType } from '@azure/msal-browser';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

const loginService = new LoginService();
const { REACT_APP_CLIENT_ID } = process.env;

export const App = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const { userAccess, userAccessFailureMessage } = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response && error.response.status === 401) {

          const payload = {
            message: "Your session has expired. Please log in again to continue.",
            actionName: "Login",
            variant: "error",
            actionOnClick: () => { window.location.reload() }
          }
          dispatch({
            type: "GLOBAL_TOAST_OPEN",
            payload
          })
        }
        console.error('Axios request failed:', error);
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      // loginService.attemptSSOSilent('loginPopup');
      const loginRequest = {
        scopes: [`openid ${REACT_APP_CLIENT_ID}/.default email profile offline_access`],
      };

      instance.ssoSilent(loginRequest).catch((error) => {
        instance.loginPopup(loginRequest).catch((popupError) => {
          console.error("Interactive login failed", popupError);
        });
      });
    }
  }, [isAuthenticated]);

  useEffect(() => {
    dispatch({ type: 'CLEAR_CONVERSATION_CHATS' });
  }, [location]);

  useEffect(() => {
    const callbackId = instance.addEventCallback((message: EventMessage) => {
      if (message.eventType === EventType.LOGIN_SUCCESS || message.eventType === EventType.SSO_SILENT_SUCCESS) {
        sessionStorage.setItem('accessToken', message.payload!['accessToken']);
        const token = message.payload!['accessToken'];
        if (token !== '') {
          loginService
            .getUserInformation(token)
            .then((userDetail: any) => {
              // sessionStorage.setItem('userDetail', JSON.stringify(userDetail));
              console.log("dfdasdasdasd", "SET_USER_DETAILS", userDetail);
              // if(userDetail?.error) {
              //   alert(userDetail?.error?.message)
              //   return;
              // }
              dispatch({
                type: 'SET_USER_DETAILS', payload: {
                  // ...userDetail,
                  accessToken: token,
                }
              });

              axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
              dispatch({
                type: 'CHECK_USER_ACCESS',
                payload: {
                  accessToken: token
                }
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } else if (message.eventType === EventType.LOGOUT_SUCCESS) {
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('userDetail');
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance]);

  if (userAccess === undefined) return (<p>Loading ...</p>)

  if (userAccess === false) return (
    <div className="!h-[100vh] flex items-center justify-center">
      <div className="text-center">
        <h5 className="text-xl">{userAccessFailureMessage?.title}</h5>
        <p>{userAccessFailureMessage?.message}</p>
      </div>
    </div>
  )

  return <Outlet />;
};